import React, { Component } from 'react';
import Firebase from 'firebase';
import { Dropdown, DropdownMenu, DropdownItem, Progress } from 'reactstrap';

class datosGlobales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            usersOnline: 0
        };
    }


    userOnline(id) {
        var usersRef = Firebase.database()
            .ref('users')
            .child(id)
            .once("value")
            .then(resp => {
                if (resp.val().last_online) {
                    var count = this.state.usersOnline ? this.state.usersOnline : 0 ;
                    var date = new Date(resp.val().last_online);
                    date.setUTCHours(5, 5, 5, 5);
                    var time = +date;
                    var d = new Date();
                    d.setUTCHours(5, 5, 5, 5);
                    var localtime = +d;
                    if(localtime === time){
                        count = count + 1
                    }
                    this.setState({usersOnline : count})
                }
            })
    }

    componentWillMount() {
        const contex = this;
        var numUsuarios = Firebase.database().ref('clients_users')
            .child(localStorage.client_id)
            .once('value', function (snapshot) {
                contex.setState({ numUsuarios: snapshot.numChildren(), usuarios: snapshot.val() });
                Object.keys(snapshot.val()).map(u => {
                    contex.userOnline(u)
                })
            });
        var numStores = Firebase.database().ref('stores')
            .child(localStorage.client_id)
            .once('value', function (snapshot) {
                contex.setState({ numStores: snapshot.numChildren() });
            })
        var dataRef = Firebase.database().ref("saved").child(localStorage.client_id);
        dataRef.on('value', snap => {
            if (snap.val()) {
                var count = 0;
                Object.values(snap.val()).map((ver) => {
                    Object.values(ver).map(c => {
                        count = count + c.raw.count;
                    })
                });
                this.setState({ countReg: count })

            } else {
                this.setState({ countReg: 0 })
            }
        })
    }

    componentWillUpdate(prevState, nextState) {

    }

    render() {
        return (
            <div className="col-md-12">
                <div className="form-group row">
                    <div className="col-md-3">
                        <div className="card">
                            <div className="card-block">
                                <div className="h1 text-muted text-right mb-2">
                                    <i className="icon-people"></i>
                                </div>
                                <div className="h4 mb-0">{this.state.numUsuarios}</div>
                                <small className="text-muted text-uppercase font-weight-bold">Usuarios</small>
                                <div className="progress progress-xs mt-1 mb-0">
                                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "25%", ariaValuenow: "25", ariaValuemin: "0", ariaValuemax: "100" }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card">
                            <div className="card-block">
                                <div className="h1 text-muted text-right mb-2">
                                    <i className="icon-screen-smartphone"></i>
                                </div>
                                <div className="h4 mb-0">{this.state.usersOnline}</div>
                                <small className="text-muted text-uppercase font-weight-bold">Usuarios online hoy</small>
                                <div className="progress progress-xs mt-1 mb-0">
                                    <div className="progress-bar bg-success" role="progressbar" style={{ width: "25%", ariaValuenow: "25", ariaValuemin: "0", ariaValuemax: "100" }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card">
                            <div className="card-block">
                                <div className="h1 text-muted text-right mb-2">
                                    <i className="icon-chart"></i>
                                </div>
                                <div className="h4 mb-0">{this.state.countReg}</div>
                                <small className="text-muted text-uppercase font-weight-bold">Registros</small>
                                <div className="progress progress-xs mt-1 mb-0">
                                    <div className="progress-bar bg-warning" role="progressbar" style={{ width: "25%", ariaValuenow: "25", ariaValuemin: "0", ariaValuemax: "100" }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card">
                            <div className="card-block">
                                <div className="h1 text-muted text-right mb-2">
                                    <i className="icon-basket"></i>
                                </div>
                                <div className="h4 mb-0">{this.state.numStores}</div>
                                <small className="text-muted text-uppercase font-weight-bold">Numero de locales</small>
                                <div className="progress progress-xs mt-1 mb-0">
                                    <div className="progress-bar" role="progressbar" style={{ width: "25%", ariaValuenow: "25", ariaValuemin: "0", ariaValuemax: "100" }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default datosGlobales;



// WEBPACK FOOTER //
// ./src/views/dashBoard/datosGlobales.js